import { graphAuxiliaryStyles } from './styles/graphAuxiliaryStyles';
import { graphBaseStyles } from './styles/graphBaseStyles';
import { graphHopStyles } from './styles/graphHopStyles';
import { graphInteractionStyles } from './styles/graphInteractionStyles';
import { graphPreviewStyles } from './styles/graphPreviewStyles';
import { simpleStylesheet } from './styles/graphSimpleStylesheet';

const stylesheet = [
  ...graphBaseStyles,
  ...graphInteractionStyles,
  ...graphPreviewStyles,
  ...graphHopStyles,
  ...graphAuxiliaryStyles,
];

const useSimpleStylesheet = false;
export const activeStylesheet = useSimpleStylesheet ? simpleStylesheet : stylesheet;
